import { Outlet } from "react-router-dom";

import { usePageTracking } from "../hooks/usePageTracking";
import WhatsNewToast from "../components/common/WhatsNewToast";
import Header from "./Header";

function Layout() {
  usePageTracking();
  return (
    <div className="Layout">
      <Header />
      <Outlet />
      <WhatsNewToast />
    </div>
  );
}

export default Layout;
